import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { StyleService } from '../../services/style.service';
@Component({
  selector: 'app-input',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility && !field.dynamic">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <textarea class="text-area resize-none focus-color" [ngStyle]="_styleService.applyStyle(field)" maxlength="1000" [disabled]="isDisabled()" value="{{field.value}}" placeholder="Enter a short description here..." (change)="onChange($event.target)"></textarea>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
<div [formGroup]="group" *ngIf="field.dynamic && field.style.visibility" class="dynamic-property">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <div *ngFor="let values of field.value; let i = index;trackBy:trackByIndex;" class="inputfields">
      <textarea class="text-area dynamic-input resize-none focus-color" [disabled]="isDisabled()" maxlength="1000" placeholder="Enter a short description here..."  [(ngModel)]="field.value[i]" [ngModelOptions]="{standalone :true}" (change)="onChangeForDynamic($event.target, i)"></textarea>
      <ng-container *ngIf="deleteShow">
      <div class="btn delete-longtext"[ngClass]="{'pointer-events' : !field.style.editability}" (click)="deletLongText(i)"><img src="assets/images/delete-dynamic.svg"></div>
      </ng-container>
    </div>
    <span class="error-message dynamic-ermsg" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
    <div class="btn-dynamic" [ngClass]="{'pointer-events' : !field.style.editability}">
      <div class="btn btn-default" (click)="dynamicLongText()"><img src="assets/images/add-img.svg"> Add another field</div>
      </div>
    </div>
  </div>
  `,
  styles: []
})
export class longTextComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  deleteShow = false;
  constructor(
    private _validationService: ValidationService,
    private  _styleService : StyleService
  ) { }
  onChange(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  mouseEnter(event) {
    this.field.value = event.value;
  }
  mouseLeave(event) {
    this.field.value = event.value;

    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onEnd]);
  }
  

  // dynamic long text 
  onChangeForDynamic(event, index) {
    this.field.value = Object.assign([], this.field.value, {
      [index]: event.value
    });
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value[this.field.id];
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onEnd]);
  }
  trackByIndex(index: number) {
    return index;
  }
  dynamicLongText() {
    this.field.value.push('');
    this.deleteShow = true;
  }
  deletLongText(i) {
    this.field.value.splice(i, 1);
    if (i === 1) {
      this.deleteShow = false;
    }
  }

  ngOnInit() {
    if (!this.field.dynamic && this.field.value === undefined && this.field.value !== " ") {
      this.field.value = '';
    }
    if (this.field.dynamic && this.field.value === undefined) {
      this.field.value = [''];
    }
    if (this.field.dynamic && this.field.value.length > 1) {
      this.deleteShow = true;
    }
  }
  isDisabled() : boolean{
    if(!this.field.style.editability)return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/longtext/long-text.component.ts